import {ApiResponse} from "../models/ApiResponse";
import MainBackendAxios from "../utils/MainBackendAxios";
import {FunctionsHelper} from "../utils/FunctionsHelper";
import {RequestActivationSubType} from "../models/RequestActivationSubType";

export const RequestActivationSubTypeService = {
    getAll: async (): Promise<ApiResponse<RequestActivationSubType[]>> => {
        try {
            const response = await MainBackendAxios.get(`/request-activation-sub-type/get-all`);

            return {
                success: true,
                status: response.status,
                data: response?.data?.data,
            };
        } catch (err: any) {
            return FunctionsHelper.getErrorFormat(err);
        }
    },
};
